import React, { useCallback } from 'react';
import "../../styles/home/showAllUsers.css";
import { useEffect, useState } from "react";
import { firebaseFirestore } from "../firebase/firebase_configuration";
import { collection, getDocs } from "firebase/firestore";

import searchIcon from "../../images/chats/search_icon.png";
import fromImage from "../../images/authentication/no_profile.png";

const ShowAllUsers = ({getShow, getSearch, setSearch, setTag}) => {
    const [getIsLoading, setIsLoading] = useState(true);
    const [getUserList, setUserList] = useState([]);
    const [getOriginalUserList, setOriginalUserList] = useState([]);

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    const onSelectUser = (id, name) => {
        const list = [
            id,
            name,
        ]
        
        setTag(
            list
        );
    };

    const getAllUsers = async () => {
        let uList = [];
        try {
            const allUsersRef = collection(firebaseFirestore, 'User Details'); 
            const allUsersSnapshot = await getDocs(allUsersRef);
            
            allUsersSnapshot.forEach((userDoc) => {
                const userDetails = [
                    userDoc.id,
                    userDoc.data().username,
                    userDoc.data().image ?? "",
                ];

                const userExists = uList.some(user => user[0] === userDoc.id);
                if (!userExists) {
                    uList.push(userDetails);
                }
            });
            setUserList(uList);
            setOriginalUserList(uList);
            setIsLoading(false);
        } catch (error) {
            console.log(`Error getting all usersP: ${error.message}`);
            setIsLoading(false);
        }
    };

    const filterUsers = useCallback(() => {
        if (getSearch === "") {
            setUserList(getOriginalUserList);
        } else {
            const filteredUsers = getOriginalUserList.filter((user) =>
                user[1].toLowerCase().includes(getSearch.toLowerCase())
            );
            setUserList(filteredUsers);
        }
    }, [getOriginalUserList, getSearch]);

    useEffect(() => {
        filterUsers();
    }, [getOriginalUserList, getSearch, filterUsers]);

    useEffect(() => {
        getAllUsers();
    }, []);

    return(
        <div className={`home_show_all_users ${getShow ? "show" : ""}`}>
            <div className="home_show_all_users_search_input_container_i">
                <div className="home_show_all_users_search_input_container">
                    <img alt='search' src={searchIcon} className="home_show_all_users_search_input_icon"/>
                    <input className="home_show_all_users_search_input_field" id="item_section_search" placeholder={`Search for any user...`} type="text" value={getSearch} onChange={onChangeSearch} />
                </div>
            </div>

            <div className="home_show_all_users_column">
                {
                    getUserList.length > 0 
                    ? getUserList.map((users, index) => (
                        <div key={index} className="home_show_all_users_tab" onClick={() => onSelectUser(users[0], users[1])}>
                            <img alt='profile' src={users[2] === "" || users[2] === null ? fromImage : users[2]} className="home_show_all_users_image" />
                            <p className="home_show_all_users_name">{users[1]}</p>
                        </div>
                    ))
                    : getIsLoading
                    ? <p className="home_show_all_users_not_found">Loading...</p>
                    : getSearch === ""
                    ? <p className="home_show_all_users_not_found">"Unable to load users 🥲"</p>    
                    : <p className="home_show_all_users_not_found">User "{getSearch}" not found...</p>
                }
            </div>
        </div>
    );
};

export default ShowAllUsers;